import React from 'react'

import CurrentBreakpointContext, {
  CurrentBreakpoint,
} from './CurrentBreakpointContext'

// Providing a Breakpoints type will allow you to use its keys easily in your
// code without having to hardcode strings
const useBreakpoints = () => {
  const value = React.useContext(CurrentBreakpointContext)

  if (!value) {
    throw new Error(
      'BreakpointsProvider is missing from the tree but is required to use the useBreakpoints hook',
    )
  }

  return value as CurrentBreakpoint
}

export default useBreakpoints
